import React, { useEffect, useState, useRef } from 'react';

type LazyRenderProps = {
  children: React.ReactNode;
}

function LazyRender({ children }: LazyRenderProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLTableRowElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return <tr ref={ref}>{isVisible ? children : null}</tr>;
}

export default LazyRender;
